import { Plus } from '@phosphor-icons/react';
import { AccentButtonOutline } from '../../../../../../shared/Buttons';
import { Entity } from '../../../../../../types/apiTypes';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';
import { useUser } from '../../../../../../utils/UserContext';

function ReferralTopBar({
  setReferralPopupVisible,
}: {
  setReferralPopupVisible: (open: boolean) => void;
}) {
  const { screenView } = useScreenView();
  const { userRecord } = useUser();
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          (userRecord?.userType === Entity.Vendor ||
            userRecord?.userType === Entity.Partner ||
            userRecord?.userType === Entity.PartnerAgent) && (
            <div className="flex w-[100%] justify-between gap-4 align-middle sm:flex-col sm:items-start md:h-[76px] md:max-h-[76px] md:flex-row md:items-center">
              <h2 className="text-[28px]">
                Your Referral Code:{' '}
                <span className="text-[30px] font-semibold">
                  {userRecord?.referral_code}
                </span>
              </h2>
              <AccentButtonOutline
                onClick={() => setReferralPopupVisible(true)}
                addClass="rounded-full px-4 py-[14px] w-[196px] h-[48px] flex flex-row items-center align-middle space-x-2 justify-center"
              >
                <Plus />
                <p>Invite Referral</p>
              </AccentButtonOutline>
            </div>
          )
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default ReferralTopBar;
